import { notification } from 'antd';
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
// import { Link } from 'react-router-dom';
import {
  Button,
  Checkbox,
  Dropdown,
  Form,
  Grid,
  Input,
  Segment,
} from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';

import customFetch from '../../../../utils/customFetch';
import iframe from '../../../dashboard-routes/Iframe/iframeData';
import DoctorDetailsStore from './DoctorDetailsStore';
import TextArea from './TextArea';
import { Upload, File, NoFile } from './Upload';
import './DoctorDetails.scss';
import { formatDate } from '../../../../utils/functions';
import moment from 'moment';
import * as api from '@stores/api';

@observer
class RecruitmentLoginInformationTab extends React.Component {
  renderClientType = type => {
    switch (type) {
      case 0:
        return 'Business Ultimate';
      case 1:
        return 'Business Direct-Essential';
      case 2:
        return 'Business Direct-Extra';
      default:
        return 'None';
    }
  };

  @action uploadContract = data => {
    const contract = data.fileList[0];
    if (contract) {
      DoctorDetailsStore.dataDoctor.ContractAttachmentDisplayName =
        contract.title;
      DoctorDetailsStore.dataDoctor.ContractAttachmentPhysicalFileName =
        contract.name;
    }
  };

  @action removeContract = () => {
    DoctorDetailsStore.dataDoctor.ContractAttachmentDisplayName = null;
    DoctorDetailsStore.dataDoctor.ContractAttachmentPhysicalFileName = null;
  };

  openClinicCalendar = () => {
    const { dataDoctor } = DoctorDetailsStore;
    iframe.forceOpenTab(
      'ManageCalendar',
      `?doctorId=${dataDoctor.Id}&view=ManageCalendar`,
      {
        doctorId: dataDoctor.Id,
        view: 'ManageCalendar',
      },
    );
  };

  notifyEnable = () => {
    DoctorDetailsStore.toggleModal(true, {
      modalType: 'alert',
      message: 'This user is not yet enabled for login. Enable login first.',
      cancelText: 'Cancel',
    })();
  };

  handleEditUser = () => {
    const { userId } = DoctorDetailsStore;
    customFetch('/Manager/GetUserById', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    }).then(
      action(data => {
        DoctorDetailsStore.dataUser = data;
        DoctorDetailsStore.toggleModal(true, { modalType: 'editUser' })();
      }),
    );
  };

  handleUnlockUser = () => {
    const { userId } = DoctorDetailsStore;
    customFetch('/manager/unlockUser', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ userId }),
    }).then(() => {
      notification.destroy();
      notification.success({
        message: 'Success',
        description: `User has been unlocked`,
        duration: 5,
      });
    });
  };

  handleResetPassword = () => {
    const userId = DoctorDetailsStore.dataDoctor.UserId;
    const doctorId = DoctorDetailsStore.dataDoctor.Id;
    customFetch('/Manager/ResetPassword', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ userId, doctorId }),
    }).then(res => {
      DoctorDetailsStore.toggleModal(true, {
        modalType: 'alert',
        withoutIcon: true,
        message: `Generated password: ${res.result}`,
        cancelText: 'Cancel',
      })();
    });
  };

  handleResendLoginInformation = () => {
    const userId = DoctorDetailsStore.dataDoctor.UserId;
    const doctorId = DoctorDetailsStore.dataDoctor.Id;
    customFetch('/Manager/ResendLoginInformation', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ uId: userId, doctorId }),
    }).then(() => {
      notification.destroy();
      notification.success({
        message: 'Success',
        description: `Resend login Information: Successfully!!`,
        duration: 5,
      });
    });
  };

  render() {
    const {
      isEditing,
      dataDoctor,
      setFieldValue,
      toggleCheckbox,
    } = DoctorDetailsStore;

    const enableLoginDate = dataDoctor.EnableLoginDate
      ? moment(
          formatDate(dataDoctor.EnableLoginDate, true),
          'DD MMM YYYY, HH:mm',
        ).format('DD/MM/YYYY')
      : '';
    const enableLoginBy = dataDoctor.EnableLoginBy
      ? dataDoctor.EnableLoginBy
      : '';

    const labelEnableLogin =
      !dataDoctor.EnableLogin || !enableLoginDate
        ? `Enable`
        : 'Enabled (' + enableLoginDate + ' - ' + enableLoginBy + ')';
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment className="Segment-View">
              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Group-label">
                      Recruitment And Login Information
                    </label>
                  </Form.Field>
                </Form.Group>
                {api.isMAG() && (
                  <Form.Field inline>
                    <label className="Form-Field-label">Service Type: </label>
                    {!isEditing ? (
                      <span>
                        {this.renderClientType(dataDoctor.ClientType)}
                      </span>
                    ) : (
                      <Dropdown
                        selection
                        name="ClientType"
                        options={[
                          {
                            value: 0,
                            text: 'Business Ultimate',
                          },
                          {
                            value: 1,
                            text: 'Business Direct-Essential',
                          },
                          {
                            value: 2,
                            text: 'Business Direct-Extra',
                          },
                        ]}
                        value={dataDoctor.ClientType}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                )}

                <Form.Field>
                  <Checkbox
                    label="Recruiting"
                    className="Form-field-radio"
                    disabled={!isEditing}
                    name="IsRecruiting"
                    checked={dataDoctor.IsRecruiting}
                    onChange={toggleCheckbox}
                  />
                  <Checkbox
                    label="Onboarding"
                    className="Form-field-radio"
                    disabled={!isEditing}
                    name="IsOnboarding"
                    checked={dataDoctor.IsOnboarding}
                    onChange={toggleCheckbox}
                  />
                  <Checkbox
                    label="Onboarded"
                    className="Form-field-radio"
                    disabled={!isEditing}
                    name="HasContractWithMag"
                    checked={dataDoctor.HasContractWithMag}
                    onChange={toggleCheckbox}
                  />
                </Form.Field>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">Recruiting Date</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.RecruitingDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="RecruitingDate"
                        animation=""
                        duration={0}
                        clearable
                        dateFormat="DD/MM/YYYY"
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.RecruitingDate }
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">PIC</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.AssignedToUserFullName || 'None'}
                        </span>
                      </div>
                    ) : (
                      <Dropdown
                        search
                        selection
                        name="AssignedToId"
                        options={DoctorDetailsStore.dataStaffs}
                        value={dataDoctor.AssignedToId}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">Campain Name</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.CampaignName || 'None'}
                        </span>
                      </div>
                    ) : (
                      <Input
                        name="CampaignName"
                        value={dataDoctor.CampaignName || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal"></Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Recruiting Comment
                    </label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.RecruitingComment || 'None'}
                        </span>
                      </div>
                    ) : (
                      <TextArea name="RecruitingComment" maxLength="2000" />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">Onboarding Date</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.OnboardingDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="OnboardingDate"
                        animation=""
                        dateFormat="DD/MM/YYYY"
                        duration={0}
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.OnboardingDate }
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Onboarding Comment
                    </label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.OnboardingComment || 'None'}
                        </span>
                      </div>
                    ) : (
                      <TextArea name="OnboardingComment" maxLength="2000" />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Onboarded Date (Contract Date)
                    </label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.ContractWithMagDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="ContractWithMagDate"
                        animation=""
                        duration={0}
                        dateFormat="DD/MM/YYYY"
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.ContractWithMagDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">
                      Contract End Date
                    </label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.ContractWithMagEndDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="ContractWithMagEndDate"
                        dateFormat="DD/MM/YYYY"
                        animation=""
                        duration={0}
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.ContractWithMagEndDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Field width="8">
                  <label className="Form-Field-label">Attach Contract</label>
                  {!isEditing ? (
                    dataDoctor.ContractAttachmentPhysicalFileName === null ? (
                      <NoFile />
                    ) : (
                      <File
                        name={dataDoctor.ContractAttachmentDisplayName}
                        downloadLink={`/UserFile/DoctorContract/${dataDoctor.ContractAttachmentPhysicalFileName}`}
                      />
                    )
                  ) : dataDoctor.ContractAttachmentPhysicalFileName === null ? (
                    <Upload
                      onComplete={this.uploadContract}
                      placeholder="Upload your contract"
                    />
                  ) : (
                    <File
                      name={dataDoctor.ContractAttachmentDisplayName}
                      downloadLink={`/UserFile/DoctorContract/${dataDoctor.ContractAttachmentPhysicalFileName}`}
                      onRemove={this.removeContract}
                    />
                  )}
                </Form.Field>
              </Form>
            </Segment>
            <Segment>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Available for Online Bookings
                    </label>
                    <Checkbox
                      label={`${
                        dataDoctor.AvailableForCMView
                          ? `Available`
                          : `Not Available`
                      }`}
                      className="Form-field-radio"
                      disabled={!isEditing}
                      name="AvailableForCMView"
                      checked={dataDoctor.AvailableForCMView}
                      onChange={toggleCheckbox}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">Enable Login</label>
                    <Checkbox
                      label={labelEnableLogin}
                      className="Form-field-radio"
                      disabled={!isEditing}
                      name="EnableLogin"
                      checked={dataDoctor.EnableLogin}
                      onChange={toggleCheckbox}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">Username</label>
                    <div>
                      <span className="Label-item">
                        {dataDoctor.Username || 'None'}
                      </span>
                    </div>
                  </Form.Field>
                </Form.Group>
                {dataDoctor.Id !== 0 && (
                  <Form.Group widths="equal">
                    <Form.Field>
                      <Button
                        color="blue"
                        onClick={
                          !dataDoctor.EnableLogin
                            ? this.notifyEnable
                            : this.handleEditUser
                        }
                      >
                        Edit Username
                      </Button>
                      <Button
                        color="blue"
                        onClick={
                          !dataDoctor.EnableLogin
                            ? this.notifyEnable
                            : this.handleUnlockUser
                        }
                      >
                        Unlock User
                      </Button>
                      <Button
                        color="blue"
                        onClick={
                          !dataDoctor.EnableLogin
                            ? this.notifyEnable
                            : DoctorDetailsStore.toggleModal(true, {
                                modalType: 'confirm',
                                message: `Do you want to reset password for user ${dataDoctor.FirstName} ${dataDoctor.LastName}? New password will be sent to the user automatically.`,
                                onOk: this.handleResetPassword,
                              })
                        }
                      >
                        Reset Password
                      </Button>
                      <Button
                        color="blue"
                        onClick={
                          !dataDoctor.EnableLogin
                            ? this.notifyEnable
                            : this.handleResendLoginInformation
                        }
                      >
                        Resend Login Information
                      </Button>
                      {dataDoctor.Username && (
                        <Button
                          color="blue"
                          onClick={() =>
                            DoctorDetailsStore.toggleModal(true, {
                              modalType: 'passwordRsHistory',
                            })()
                          }
                        >
                          Password Reset History
                        </Button>
                      )}
                    </Form.Field>
                  </Form.Group>
                )}
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">
                      Not Currently Interested (NCI)
                    </label>
                    <Checkbox
                      label="Not Currently Interested (NCI)"
                      className="Form-field-radio"
                      disabled={!isEditing}
                      name="IsNotCurrentlyInterested"
                      checked={dataDoctor.IsNotCurrentlyInterested}
                      onChange={toggleCheckbox}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">NCI Start Date:</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.NotCurrentlyInterestedDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="NotCurrentlyInterestedDate"
                        dateFormat="DD/MM/YYYY"
                        animation=""
                        duration={0}
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.NotCurrentlyInterestedDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                  <Form.Field>
                    <label className="Form-Field-label">NCI End Date:</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.NotCurrentlyInterestedEndDate || 'None'}
                        </span>
                      </div>
                    ) : (
                      <DateInput
                        name="NotCurrentlyInterestedEndDate"
                        dateFormat="DD/MM/YYYY"
                        animation=""
                        duration={0}
                        clearable
                        placeholder="dd/mm/yyyy"
                        value={dataDoctor.NotCurrentlyInterestedEndDate || ''}
                        onChange={setFieldValue}
                      />
                    )}
                  </Form.Field>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="Form-Field-label">NCI Comment</label>
                    {!isEditing ? (
                      <div>
                        <span className="Label-item">
                          {dataDoctor.NotCurrentlyInterestedComment || 'None'}
                        </span>
                      </div>
                    ) : (
                      <TextArea
                        name="NotCurrentlyInterestedComment"
                        maxLength="2000"
                      />
                    )}
                  </Form.Field>
                </Form.Group>
              </Form>
            </Segment>
          </Grid.Column>
          {this.props.children}
        </Grid.Row>
      </Grid>
    );
  }
}
export default RecruitmentLoginInformationTab;
